module.exports = __webpack_public_path__ + "img/step20_1_mfp_locate_refeed_preventers.1b8879a3.png";